// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Button = createStyle({
  borderRadius: '$md',
  backgroundColor: '$actionPrimary',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',

  _text: {
    color: '$textInverted',
    fontWeight: 'semibold',
    _dark: {
      color: '$textInverted',
    },
  },

  _icon: {
    color: '$textInverted',
    _dark: {
      color: '$textInverted',
    },
  },

  _spinner: {
    props: {
      color: '$textInverted',
    },
    _dark: {
      props: {
        color: '$textInverted',
      },
    },
  },

  variants: {
    action: {
      primary: {
        bg: '$brandBase',
        borderColor: '$brandBase',

        ':hover': {
          bg: '$brandHover',
          borderColor: '$brandHover',
        },

        ':active': {
          bg: '$brandActive',
          borderColor: '$brandActive',
        },

        _text: {
          color: '$textOnBrand',
          ':hover': {
            color: '$textOnBrand',
          },
          ':active': {
            color: '$textOnBrand',
          },
        },

        _icon: {
          color: '$textOnBrand',
          ':hover': {
            color: '$textOnBrand',
          },
          ':active': {
            color: '$textOnBrand',
          },
        },

        _spinner: {
          props: {
            color: '$textOnBrand',
          },
          ':hover': {
            props: {
              color: '$textOnBrand',
            },
          },
          ':active': {
            props: {
              color: '$textOnBrand',
            },
          },
        },

        _dark: {
          bg: '$brandBase',
          borderColor: '$brandBase',
          ':hover': {
            bg: '$brandHover',
            borderColor: '$brandHover',
          },
          ':active': {
            bg: '$brandActive',
            borderColor: '$brandActive',
          },
          _text: {
            color: '$textOnBrand',
            ':hover': {
              color: '$textOnBrand',
            },
            ':active': {
              color: '$textOnBrand',
            },
          },
          _icon: {
            color: '$textOnBrand',
            ':hover': {
              color: '$textOnBrand',
            },
            ':active': {
              color: '$textOnBrand',
            },
          },
          _spinner: {
            props: { color: '$textOnBrand' },
            ':hover': {
              props: { color: '$textOnBrand' },
            },
            ':active': {
              props: { color: '$textOnBrand' },
            },
          },

          ':focusVisible': {
            _web: {
              boxShadow: 'offset 0 0 0 2px $borderFocus',
            },
          },
        },
      },
      secondary: {
        bg: '$bgApp',
        borderColor: '$borderLight',
        borderWidth: 1,

        ':hover': {
          bg: '$bgHover',
          borderColor: '$borderMedium',
        },

        ':active': {
          bg: '$bgApp',
          borderColor: '$borderMedium',
        },

        _text: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _icon: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },

        _spinner: {
          props: {
            color: '$textBody',
          },
          ':hover': {
            props: { color: '$textHeading' },
          },
          ':active': {
            props: { color: '$textHeading' },
          },
        },

        _dark: {
          bg: '$bgCard',
          borderColor: '$borderLight',
          ':hover': {
            bg: '$bgHover',
            borderColor: '$borderMedium',
          },
          ':active': {
            bg: '$bgCard',
            borderColor: '$borderMedium',
          },
          _text: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _icon: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _spinner: {
            props: {
              color: '$textBody',
            },
            ':hover': {
              props: { color: '$textHeading' },
            },
            ':active': {
              props: { color: '$textHeading' },
            },
          },
        },
      },
      positive: {
        bg: '$statusSuccess',
        borderColor: '$statusSuccessSubtle',
        ':hover': {
          bg: '$statusSuccess',
          borderColor: '$statusSuccess',
        },

        ':active': {
          bg: '$statusSuccess',
          borderColor: '$statusSuccess',
        },

        _text: {
          color: '$textInverted',
          ':hover': {
            color: '$textInverted',
          },
          ':active': {
            color: '$textInverted',
          },
        },
        _icon: {
          color: '$textInverted',
          ':hover': {
            color: '$textInverted',
          },
          ':active': {
            color: '$textInverted',
          },
        },
        _spinner: {
          props: {
            color: '$textInverted',
          },
          ':hover': {
            props: { color: '$textInverted' },
          },
          ':active': {
            props: { color: '$textInverted' },
          },
        },
        _dark: {
          bg: '$statusSuccess',
          borderColor: '$statusSuccess',
          ':hover': {
            bg: '$statusSuccess',
            borderColor: '$statusSuccess',
          },
          ':active': {
            bg: '$statusSuccess',
            borderColor: '$statusSuccess',
          },
          _text: {
            color: '$textInverted',
            ':hover': {
              color: '$textInverted',
            },
            ':active': {
              color: '$textInverted',
            },
          },
          _icon: {
            color: '$textInverted',
            ':hover': {
              color: '$textInverted',
            },
            ':active': {
              color: '$textInverted',
            },
          },
          _spinner: {
            props: {
              color: '$textInverted',
            },
            ':hover': {
              props: { color: '$textInverted' },
            },
            ':active': {
              props: { color: '$textInverted' },
            },
          },
          ':focusVisible': {
            _web: {
              boxShadow: 'offset 0 0 0 2px $borderFocus',
            },
          },
        },
      },
      negative: {
        bg: '$statusError',
        borderColor: '$statusErrorSubtle',
        ':hover': {
          bg: '$statusError',
          borderColor: '$statusError',
        },

        ':active': {
          bg: '$statusError',
          borderColor: '$statusError',
        },
        _text: {
          color: '$textInverted',
          ':hover': {
            color: '$textInverted',
          },
          ':active': {
            color: '$textInverted',
          },
        },
        _icon: {
          color: '$textInverted',
          ':hover': {
            color: '$textInverted',
          },
          ':active': {
            color: '$textInverted',
          },
        },
        _spinner: {
          props: {
            color: '$textInverted',
          },
          ':hover': {
            props: { color: '$textInverted' },
          },
          ':active': {
            props: { color: '$textInverted' },
          },
        },
        _dark: {
          bg: '$statusError',
          borderColor: '$statusError',
          ':hover': {
            bg: '$statusError',
            borderColor: '$statusError',
          },
          ':active': {
            bg: '$statusError',
            borderColor: '$statusError',
          },
          _text: {
            color: '$textInverted',
            ':hover': {
              color: '$textInverted',
            },
            ':active': {
              color: '$textInverted',
            },
          },
          _icon: {
            color: '$textInverted',
            ':hover': {
              color: '$textInverted',
            },
            ':active': {
              color: '$textInverted',
            },
          },
          _spinner: {
            props: {
              color: '$textInverted',
            },
            ':hover': {
              props: { color: '$textInverted' },
            },
            ':active': {
              props: { color: '$textInverted' },
            },
          },
          ':focusVisible': {
            _web: {
              boxShadow: 'offset 0 0 0 2px $borderFocus',
            },
          },
        },
      },

      default: {
        bg: 'transparent',
        ':hover': {
          bg: '$bgHover',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          ':hover': {
            bg: '$bgHover',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },

    variant: {
      link: {
        px: '$0',
        borderWidth: 0,
        ':hover': {
          _text: {
            // textDecorationLine: 'underline',
          },
        },
        ':active': {
          _text: {
            // textDecorationLine: 'underline',
          },
        },
      },
      outline: {
        bg: 'transparent',
        borderWidth: '$1',
        borderColor: '$borderLight',
        ':hover': {
          bg: '$bgHover',
          borderColor: '$borderMedium',
        },
        ':active': {
          bg: 'transparent',
          borderColor: '$borderMedium',
        },
        _dark: {
          bg: 'transparent',
          borderColor: '$borderLight',
          ':hover': {
            bg: '$bgHover',
            borderColor: '$borderMedium',
          },
          ':active': {
            bg: 'transparent',
            borderColor: '$borderMedium',
          },
        },
      },
      solid: {
        _text: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _spinner: {
          props: { color: '$textLight0' },
          ':hover': {
            props: { color: '$textLight0' },
          },
          ':active': {
            props: { color: '$textLight0' },
          },
        },
        _icon: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _dark: {
          _text: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _spinner: {
            props: { color: '$textDark0' },
            ':hover': {
              props: { color: '$textDark0' },
            },
            ':active': {
              props: { color: '$textDark0' },
            },
          },
          _icon: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
        },
      },
    },

    size: {
      xs: {
        px: '$3.5',
        h: '$8',
        _icon: {
          props: {
            size: '2xs',
          },
        },
        _text: {
          props: {
            size: 'xs',
          },
        },
      },
      sm: {
        px: '$4',
        h: '$9',
        _icon: {
          props: {
            size: 'sm',
          },
        },
        _text: {
          props: {
            size: 'sm',
          },
        },
      },
      md: {
        px: '$5',
        h: '$10',
        _icon: {
          props: {
            size: 'md',
          },
        },
        _text: {
          props: {
            size: 'md',
          },
        },
      },
      lg: {
        px: '$6',
        h: '$11',
        _icon: {
          props: {
            size: 'md',
          },
        },
        _text: {
          props: {
            size: 'lg',
          },
        },
      },
      xl: {
        px: '$7',
        h: '$12',
        _icon: {
          props: {
            size: 'lg',
          },
        },
        _text: {
          props: {
            size: 'xl',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      action: 'primary',
      variant: 'link',
      value: {
        px: '$0',
        borderWidth: 0,
        bg: 'transparent',
        _text: {
          color: '$brandBase',
          ':hover': {
            color: '$brandHover',
          },
          ':active': {
            color: '$brandActive',
          },
        },
        _icon: {
          color: '$brandBase',
          ':hover': {
            color: '$brandHover',
          },
          ':active': {
            color: '$brandActive',
          },
        },
        _spinner: {
          props: {
            color: '$brandBase',
          },
          ':hover': {
            props: {
              color: '$brandHover',
            },
          },
          ':active': {
            props: {
              color: '$brandActive',
            },
          },
        },
        ':hover': {
          bg: 'transparent',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          _text: {
            color: '$brandBase',
            ':hover': {
              color: '$brandHover',
            },
            ':active': {
              color: '$brandActive',
            },
          },
          _icon: {
            color: '$brandBase',
            ':hover': {
              color: '$brandHover',
            },
            ':active': {
              color: '$brandActive',
            },
          },
          ':hover': {
            bg: 'transparent',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'secondary',
      variant: 'link',
      value: {
        px: '$0',
        borderWidth: 0,
        bg: 'transparent',
        _text: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _icon: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        ':hover': {
          bg: 'transparent',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          _text: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _icon: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          ':hover': {
            bg: 'transparent',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'positive',
      variant: 'link',
      value: {
        px: '$0',
        borderWidth: 0,
        bg: 'transparent',
        _text: {
          color: '$statusSuccess',
          ':hover': {
            color: '$statusSuccess',
          },
          ':active': {
            color: '$statusSuccess',
          },
        },
        _icon: {
          color: '$statusSuccess',
          ':hover': {
            color: '$statusSuccess',
          },
          ':active': {
            color: '$statusSuccess',
          },
        },
        _spinner: {
          props: {
            color: '$statusSuccess',
          },
          ':hover': {
            props: {
              color: '$statusSuccess',
            },
          },
          ':active': {
            props: {
              color: '$statusSuccess',
            },
          },
        },
        ':hover': {
          bg: 'transparent',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          _text: {
            color: '$statusSuccess',
            ':hover': {
              color: '$statusSuccess',
            },
            ':active': {
              color: '$statusSuccess',
            },
          },
          _icon: {
            color: '$statusSuccess',
            ':hover': {
              color: '$statusSuccess',
            },
            ':active': {
              color: '$statusSuccess',
            },
          },
          ':hover': {
            bg: 'transparent',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'negative',
      variant: 'link',
      value: {
        px: '$0',
        borderWidth: 0,
        bg: 'transparent',
        _text: {
          color: '$statusError',
          ':hover': {
            color: '$statusError',
          },
          ':active': {
            color: '$statusError',
          },
        },
        _icon: {
          color: '$statusError',
          ':hover': {
            color: '$statusError',
          },
          ':active': {
            color: '$statusError',
          },
        },
        _spinner: {
          props: {
            color: '$statusError',
          },
          ':hover': {
            props: {
              color: '$statusError',
            },
          },
          ':active': {
            props: {
              color: '$statusError',
            },
          },
        },
        ':hover': {
          bg: 'transparent',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          _text: {
            color: '$statusError',
            ':hover': {
              color: '$statusError',
            },
            ':active': {
              color: '$statusError',
            },
          },
          _icon: {
            color: '$statusError',
            ':hover': {
              color: '$statusError',
            },
            ':active': {
              color: '$statusError',
            },
          },
          ':hover': {
            bg: 'transparent',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'primary',
      variant: 'outline',
      value: {
        bg: 'transparent',
        borderColor: '$borderBrand',
        _text: {
          color: '$brandBase',
          ':hover': {
            color: '$brandHover',
          },
          ':active': {
            color: '$brandActive',
          },
        },
        _icon: {
          color: '$brandBase',
          ':hover': {
            color: '$brandHover',
          },
          ':active': {
            color: '$brandActive',
          },
        },
        _spinner: {
          props: {
            color: '$brandBase',
          },
          ':hover': {
            props: {
              color: '$brandHover',
            },
          },
          ':active': {
            props: {
              color: '$brandActive',
            },
          },
        },
        ':hover': {
          bg: '$bgBrandSubtle',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          borderColor: '$borderBrand',
          _text: {
            color: '$brandBase',
            ':hover': {
              color: '$brandHover',
            },
            ':active': {
              color: '$brandActive',
            },
          },
          _icon: {
            color: '$brandBase',
            ':hover': {
              color: '$brandHover',
            },
            ':active': {
              color: '$brandActive',
            },
          },
          ':hover': {
            bg: '$bgBrandSubtle',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'secondary',
      variant: 'outline',
      value: {
        bg: 'transparent',
        borderColor: '$borderLight',
        _text: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _icon: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _spinner: {
          props: {
            color: '$textBody',
          },
          ':hover': {
            props: {
              color: '$textHeading',
            },
          },
          ':active': {
            props: {
              color: '$textHeading',
            },
          },
        },
        ':hover': {
          bg: '$bgHover',
          borderColor: '$borderMedium',
        },
        ':active': {
          bg: 'transparent',
          borderColor: '$borderMedium',
        },
        _dark: {
          bg: 'transparent',
          borderColor: '$borderLight',
          _text: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _icon: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          ':hover': {
            bg: '$bgHover',
            borderColor: '$borderMedium',
          },
          ':active': {
            bg: 'transparent',
            borderColor: '$borderMedium',
          },
        },
      },
    },
    {
      action: 'positive',
      variant: 'outline',
      value: {
        bg: 'transparent',
        borderColor: '$borderSuccess',
        _text: {
          color: '$statusSuccess',
          ':hover': {
            color: '$statusSuccess',
          },
          ':active': {
            color: '$statusSuccess',
          },
        },
        _icon: {
          color: '$statusSuccess',
          ':hover': {
            color: '$statusSuccess',
          },
          ':active': {
            color: '$statusSuccess',
          },
        },
        _spinner: {
          props: {
            color: '$statusSuccess',
          },
          ':hover': {
            props: {
              color: '$statusSuccess',
            },
          },
          ':active': {
            props: {
              color: '$statusSuccess',
            },
          },
        },
        ':hover': {
          bg: '$statusSuccessSubtle',
          borderColor: '$statusSuccess',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          borderColor: '$borderSuccess',
          _text: {
            color: '$statusSuccess',
            ':hover': {
              color: '$statusSuccess',
            },
            ':active': {
              color: '$statusSuccess',
            },
          },
          _icon: {
            color: '$statusSuccess',
            ':hover': {
              color: '$statusSuccess',
            },
            ':active': {
              color: '$statusSuccess',
            },
          },
          ':hover': {
            bg: '$statusSuccessSubtle',
            borderColor: '$statusSuccess',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'negative',
      variant: 'outline',
      value: {
        bg: 'transparent',
        borderColor: '$borderError',
        _text: {
          color: '$statusError',
          ':hover': {
            color: '$statusError',
          },
          ':active': {
            color: '$statusError',
          },
        },
        _icon: {
          color: '$statusError',
          ':hover': {
            color: '$statusError',
          },
          ':active': {
            color: '$statusError',
          },
        },
        _spinner: {
          props: {
            color: '$statusError',
          },
          ':hover': {
            props: {
              color: '$statusError',
            },
          },
          ':active': {
            props: {
              color: '$statusError',
            },
          },
        },
        ':hover': {
          bg: '$statusErrorSubtle',
          borderColor: '$statusError',
        },
        ':active': {
          bg: 'transparent',
        },
        _dark: {
          bg: 'transparent',
          borderColor: '$borderError',
          _text: {
            color: '$statusError',
            ':hover': {
              color: '$statusError',
            },
            ':active': {
              color: '$statusError',
            },
          },
          _icon: {
            color: '$statusError',
            ':hover': {
              color: '$statusError',
            },
            ':active': {
              color: '$statusError',
            },
          },
          ':hover': {
            bg: '$statusErrorSubtle',
            borderColor: '$statusError',
          },
          ':active': {
            bg: 'transparent',
          },
        },
      },
    },
    {
      action: 'default',
      variant: 'solid',
      value: {
        _text: {
          color: '$textBody',
        },
        _icon: {
          color: '$textBody',
        },
        _spinner: {
          props: { color: '$textBody' },
        },
      },
    },
    {
      action: 'default',
      variant: 'outline',
      value: {
        _text: {
          color: '$textBody',
        },
        _icon: {
          color: '$textBody',
        },
        _spinner: {
          props: { color: '$textBody' },
        },
      },
    },
    {
      action: 'default',
      variant: 'link',
      value: {
        _text: {
          color: '$textBody',
        },
        _icon: {
          color: '$textBody',
        },
        _spinner: {
          props: { color: '$textBody' },
        },
      },
    },
    {
      action: 'primary',
      variant: 'solid',
      value: {
        _text: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _icon: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _spinner: {
          props: { color: '$textLight0' },
          ':hover': {
            props: { color: '$textLight0' },
          },
          ':active': {
            props: { color: '$textLight0' },
          },
        },
        _dark: {
          _text: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _icon: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _spinner: {
            props: { color: '$textDark0' },
            ':hover': {
              props: { color: '$textDark0' },
            },
            ':active': {
              props: { color: '$textDark0' },
            },
          },
        },
      },
    },
    {
      action: 'secondary',
      variant: 'solid',
      value: {
        _text: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _icon: {
          color: '$textBody',
          ':hover': {
            color: '$textHeading',
          },
          ':active': {
            color: '$textHeading',
          },
        },
        _spinner: {
          props: { color: '$textBody' },
          ':hover': {
            props: { color: '$textHeading' },
          },
          ':active': {
            props: { color: '$textHeading' },
          },
        },
        _dark: {
          _text: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _icon: {
            color: '$textBody',
            ':hover': {
              color: '$textHeading',
            },
            ':active': {
              color: '$textHeading',
            },
          },
          _spinner: {
            props: { color: '$textBody' },
            ':hover': {
              props: { color: '$textHeading' },
            },
            ':active': {
              props: { color: '$textHeading' },
            },
          },
        },
      },
    },
    {
      action: 'positive',
      variant: 'solid',
      value: {
        _text: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _icon: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _spinner: {
          props: { color: '$textLight0' },
          ':hover': {
            props: { color: '$textLight0' },
          },
          ':active': {
            props: { color: '$textLight0' },
          },
        },

        _dark: {
          _text: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _icon: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _spinner: {
            props: { color: '$textDark0' },
            ':hover': {
              props: { color: '$textDark0' },
            },
            ':active': {
              props: { color: '$textDark0' },
            },
          },
        },
      },
    },
    {
      action: 'negative',
      variant: 'solid',
      value: {
        _text: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _icon: {
          color: '$textLight0',
          ':hover': {
            color: '$textLight0',
          },
          ':active': {
            color: '$textLight0',
          },
        },
        _spinner: {
          props: { color: '$textLight0' },
          ':hover': {
            props: { color: '$textLight0' },
          },
          ':active': {
            props: { color: '$textLight0' },
          },
        },
        _dark: {
          _text: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _icon: {
            color: '$textDark0',
            ':hover': {
              color: '$textDark0',
            },
            ':active': {
              color: '$textDark0',
            },
          },
          _spinner: {
            props: { color: '$textDark0' },
            ':hover': {
              props: { color: '$textDark0' },
            },
            ':active': {
              props: { color: '$textDark0' },
            },
          },
        },
      },
    },
  ],

  props: {
    size: 'sm',
    variant: 'solid',
    action: 'primary',
  },

  _web: {
    // ':focusVisible': {
    //   outlineWidth: '$0.5',
    //   outlineColor: '$primary700',
    //   outlineStyle: 'solid',
    //   _dark: {
    //     outlineColor: '$primary300',
    //   },
    // },
  },

  ':disabled': {
    opacity: 0.4,
  },
});
